// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".__big-wheel[data-v-0ace0b08]{position:relative;display:inline-block}.__big-wheel .wrap[data-v-0ace0b08]{position:absolute;width:100%;height:100%}.__big-wheel .wrap .prize-wrap[data-v-0ace0b08]{position:absolute;left:25%;top:0;width:50%;height:50%}.__big-wheel .wrap .prize-wrap .item[data-v-0ace0b08]{position:absolute;left:0;top:0;width:100%;height:100%;-webkit-transform-origin:center bottom;transform-origin:center bottom}", ""]);
// Exports
module.exports = exports;
